import axios from "axios";
import api from "../../services/axiosHeader.js";
import { rgpd } from "../../../api/entryPoint";
import { authHeader } from '../../helpers/authservice/auth-header.js';

export const state = {
    rgpd: {},
    isLoading: true,
}

export const mutations = {
    SET_RGPD(state, newValue) {
        state.rgpd = newValue;
    },
    SET_IS_LOADING(state, payload) {
        state.isLoading = payload;
    },
}
export const getters = {
    getRgpd(state) {
        return state.rgpd;
    },
    getIsLoading(state) {
        return state.isLoading;
    },
}

export const actions = {
    // List all rgpd
    contentRgpd({ commit }) {
        commit('SET_IS_LOADING', true);
        axios.get(rgpd, {
            "Accept": "application/json",
            headers: authHeader()
        }).then((res) => {
            commit('SET_RGPD', res.data)
            commit('SET_IS_LOADING', false);
        }).catch((error) => {
            console.log(error);
        });
    },

    /* edit  Rgpd */
    editRgpd({ commit }, payload) {
        commit('SET_IS_LOADING', true);
        let data = {
            "content": payload,
        }
        api.patch(rgpd + '/' + 1, data)
            .then((res) => {
                if (res.data.code === 200) {
                    commit('SET_IS_LOADING', false);
                }
            }).catch((error) => {
                console.log(error);
            });
    },
}